import * as React from 'react';

import './style.scss';

interface ITileHeaderProps {
  title?: any;
  renderTitle?: () => JSX.Element;
  renderLink?: () => JSX.Element;
  // collapse props
  onCollapseToggle?: (e: any) => void;
}

export default class TileHeader extends React.Component<ITileHeaderProps, {}> {
  static defaultProps: ITileHeaderProps = {
    title: 'Insert title',
    onCollapseToggle: null,
    renderTitle: null,
    renderLink: null,
  };

  renderTitle = () => (this.props.renderTitle ? this.props.renderTitle() : <h2>{this.props.title}</h2>);

  render() {
    const className = 'tile-header-container';

    return (
      <div className={className}>
        <div key={1} className="tile-header" onClick={this.props.onCollapseToggle}>
          {this.props.onCollapseToggle && <span className="tile-header__arrow" />}
          <div className="tile-header__content">
            {this.renderTitle()}
            {this.props.renderLink && (
              <div className="tile-header__link" onClick={(e) => e.stopPropagation()}>
                {this.props.renderLink()}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
